import ExpenseGrid from "./ExpenseGrid";
import moment from "moment";
import ExpenseFilter from "./ExpenseFilter";
import {Button, Card, Typography} from "antd";
import {t} from "i18next";
import {useHistory} from "react-router-dom";
import SimpleLayout from "../../../core/components/layout/SimpleLayout";
import {PERMISSIONS, useUser} from "../../../core/context/UserContext";
import {DataGridProvider} from "../../../core/components/data-grid/DataGridContext";
import {useEffect} from "react";
import AppConfig from "../../../core/service/AppConfig";

export default function ExpenseGridApp()
{
    const history = useHistory();
    const {hasPermission} = useUser()

    const Title = () => {
        return (
            <div
                style={{display: 'flex', gap: 12, alignItems: 'center'}}
            >
                <Typography.Text>
                    {t('Expenses')}
                </Typography.Text>
                {hasPermission(PERMISSIONS.EXPENSE_CREATE_EDIT) && <Button size={'small'} type={'primary'} onClick={() => history.push(`/app/expenses/create`)}>{t('+')}</Button>}
            </div>
        )
    }

    useEffect(() => {
        document.title = `${t('Expenses')} - ${AppConfig.getHisTitle()}`
    }, []);

    return (
        <SimpleLayout fullWidth={true}>
            <Card title={<Title />}>
                <DataGridProvider
                    defaultFilter={{
                        startDate: moment(),
                        endDate: moment()
                    }}
                >
                    <ExpenseGrid />
                </DataGridProvider>
            </Card>
        </SimpleLayout>
    )
}
